// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1sSiF","clinicsSelect":"TableHeading_clinicsSelect__2tr-o"};